<template>
  <div id="app">
    <div class="navbar">
      <img src="./assets/img/logo.png" class="logo">
      <!-- <ul class="routerList">
        <li class="list"><a href="javascript">产品</a></li>
        <li class="list"><a href="javascript">方案</a></li>
        <li class="list"><a href="javascript">SDK</a></li>
        <li class="list"><a href="javascript">帮助</a></li>
        <li class="list"><a href="javascript">联系</a></li>

        <li class="list"><router-link to="/product">产品</router-link></li>
        <li class="list"><router-link to="/programme">方案</router-link></li>
        <li class="list"><router-link to="/SDK">SDK</router-link></li>
        <li class="list"><router-link to="/help">帮助</router-link></li>
        <li class="list"><router-link to="/contact">联系</router-link></li>
      </ul> -->
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style lang="less" src="./assets/less/common.less"></style>
<style lang="less">
  #app {
    .navbar{
      height: 76px;
      width:100%;
      line-height: 76px;
      position: absolute;
      z-index: 10;
      .logo{
        margin-left:18.5417%;margin-top: 16px;
      }
      .routerList{
        float: right;margin-right:14.5833%;
        .list{
          float: left;padding: 0 24px;
          a{
            font-size: 16px;color: #fff;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?72e69b7d